import Shimmer from "@components/core/Shimmer/Shimmer";
import ShimmerWrapper from "@components/core/Shimmer/ShimmerWrapper";

const HeaderTitleSkeleton = () => {
    return (
        <ShimmerWrapper direction='column' spacing={8} align='flex-start'>
            <Shimmer width='320px' height={24} />
            <Shimmer width='140px' height={12} />
        </ShimmerWrapper>
    )
}
const HeaderActionSkeleton = () => {
    return (
        <ShimmerWrapper direction='row' spacing={8} justify='flex-end'>
            <Shimmer width='36px' height={36} radius={6} />
            <Shimmer width='36px' height={36} radius={6} />
            <Shimmer width='36px' height={36} radius={6} />
            <Shimmer width='36px' height={36} radius={6} />
            <Shimmer width='36px' height={36} radius={6} />
        </ShimmerWrapper>
    )
}

const HeaderDropdownSkeleton = () => {
    return (
        <ShimmerWrapper direction='row' spacing={8} justify='flex-end'>
            <Shimmer width='140px' height={36} radius={6} />
        </ShimmerWrapper>
    )
}

const HeaderSkeleton = () => {
    return (
        <ShimmerWrapper spacing={8} className={`padding-vertical`}
            display='grid'
            style={{ gridTemplateColumns: '3fr 1fr 1fr' }} >
            <HeaderTitleSkeleton />
            <HeaderActionSkeleton />
            <HeaderDropdownSkeleton />
        </ShimmerWrapper >
    );
};


HeaderSkeleton.HeaderTitleSkeleton = HeaderTitleSkeleton;
HeaderSkeleton.HeaderActionSkeleton = HeaderActionSkeleton;
HeaderSkeleton.HeaderDropdownSkeleton = HeaderDropdownSkeleton;

export default HeaderSkeleton;